import {Route} from "../../registry/routes.js"
import Upload from "../../components/files/Upload.vue"

const r = new Route("upload", "upload", {"upload":Upload}, {componentType:"modal_component", title: "Upload"}, [], true, null)

export default r